import { Button, Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import type { ReceivedCancellationRequestRoot } from '@repo/sdk'

import { ProductCell } from '../../components/ProductCell'
import { formatKrw } from '@repo/shared'
import { formatOrderBriefLabel } from '../orders/orderDisplay'

interface CancellationOrderInfoCardProps {
  cancellation: ReceivedCancellationRequestRoot
}

export function CancellationOrderInfoCard({ cancellation }: CancellationOrderInfoCardProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Card title={t('pages.cancellations.sections.orderInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.cancellations.fields.orderId')}>
          <Button
            data-testid="cancellation-detail-order-link"
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => void navigate(`/orders/${cancellation.order.fulfillmentOrderId}`)}
          >
            {formatOrderBriefLabel(cancellation.order)}
          </Button>
        </Descriptions.Item>
        {cancellation.orderItems?.map((item) => (
          <Descriptions.Item
            key={item.productId}
            label={<ProductCell name={item.productName} thumbnailUrl={item.productImageUrl} />}
          >
            {`${item.quantity} x ${formatKrw(item.unitPrice.amount)}`}
          </Descriptions.Item>
        ))}
        <Descriptions.Item label={t('pages.cancellations.fields.refundAmount')}>
          {formatKrw(cancellation.expectedRefundAmount.amount)}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
